module.exports = __webpack_public_path__ + "static/img/gl-3.59041aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gallery/gl-3.jpg
// module id = mIIG
// module chunks = 0